export default {
  // TODO:: Add permissions for live tracking and sensors.
  liveTracking: {
    title: 'Live Tracking',
    details: 'Live tracking, location & trip replay and other map related features',
    icon: 'crosshairs',
    iconClass: 'color-deep-orange-300',
    routerTo: { name: 'live-monitoring' },
    searchTags: ['monitoring', 'live tracking', 'maps', 'locations', 'trips'],
    security: { check: false, permission: '', action: '' }
  },
  liveSensors: {
    title: 'Live Sensor Monitoring',
    details: 'Live monitoring of vehicle/unit sensors',
    icon: 'microchip',
    iconClass: 'color-deep-orange-300',
    routerTo: { name: 'live-sensor-monitoring' },
    searchTags: ['monitoring', 'live sensors', 'maps', 'sensors', 'live'],
    security: { check: false, permission: '', action: '' }
  },
  liveEvents: {
    title: 'Live Event Monitoring',
    details: 'Live monitoring of events',
    icon: 'alarm-exclamation',
    iconClass: 'color-deep-orange-300',
    routerTo: { name: 'live-event-monitoring' },
    searchTags: ['monitoring', 'live sensors', 'live events', 'maps', 'sensors', 'events', 'live'],
    security: { check: false, permission: '', action: '' }
  },
  vehicleCreate: {
    title: 'Add Vehicle',
    details: 'Add a vehicle to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'vehicle-create' },
    searchTags: ['add vehicles', 'assets'],
    security: { check: true, permission: 'vehicles', action: 'create' }
  },
  vehicleFind: {
    title: 'Find Vehicle',
    details: 'Find and view existing vehicles',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'vehicle-find' },
    searchTags: ['find vehicles', 'view vehicles', 'assets'],
    security: { check: true, permission: 'vehicles', action: 'view' }
  },
  vehicleExpenses: {
    title: 'Vehicle Expenditure',
    details: 'Manage vehicle expenditure/expenses',
    icon: 'money-check-edit-alt',
    iconClass: 'color-blue-300',
    routerTo: { name: 'vehicle-expenses' },
    searchTags: ['vehicles', 'expenses', 'expenditures', 'assets'],
    security: { check: true, permission: 'vehicle_expenses', action: '' }
  },
  vehicleGroupCreate: {
    title: 'Add Vehicle Group',
    details: 'Add a new vehicle group to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'vehicle-group-create' },
    searchTags: ['add vehicle groups', 'add groups', 'assets', 'vehicles'],
    security: { check: true, permission: 'vehicle_groups', action: 'create' }
  },
  vehicleGroupFind: {
    title: 'Find Vehicle Group',
    details: 'Find and view existing vehicles groups',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'vehicle-group-find' },
    searchTags: ['find vehicle groups', 'view vehicle groups', 'find groups', 'view groups', 'assets', 'vehicles'],
    security: { check: true, permission: 'vehicle_groups', action: 'view' }
  },
  driverCreate: {
    title: 'Add Driver',
    details: 'Add a new driver to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'driver-create' },
    searchTags: ['add drivers', 'assets'],
    security: { check: true, permission: 'drivers', action: 'create' }
  },
  driverFind: {
    title: 'Find Driver',
    details: 'Find and view existing drivers',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'driver-find' },
    searchTags: ['find drivers', 'view drivers', 'assets'],
    security: { check: true, permission: 'drivers', action: 'view' }
  },
  accountTypeCreate: {
    title: 'Add Account Type',
    details: 'Add a new account type for the users you are managing',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'account-type-create' },
    searchTags: ['add account types', 'administration'],
    security: { check: true, permission: 'account_types', action: 'create' }
  },
  accountTypeFind: {
    title: 'Find Account Type',
    details: 'Find and view existing account types',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'account-type-find' },
    searchTags: ['find account types', 'view account types', 'find accounts', 'view accounts', 'administration'],
    security: { check: true, permission: 'account_types', action: 'view' }
  },
  partnerCreate: {
    title: 'Add Partner',
    details: 'Add a new partner to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'partner-create' },
    searchTags: ['add partners', 'administration'],
    security: { check: true, permission: 'partners', action: 'create' }
  },
  partnerFind: {
    title: 'Find Partner',
    details: 'Find and view existing partners',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'partner-find' },
    searchTags: ['find partners', 'view partners', 'administration'],
    security: { check: true, permission: 'partners', action: 'view' }
  },
  agencyCreate: {
    title: 'Add Agency',
    details: 'Add a new agency to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'agency-create' },
    searchTags: ['add agencies', 'add agency', 'administration'],
    security: { check: true, permission: 'agencies', action: 'create' }
  },
  agencyFind: {
    title: 'Find Agency',
    details: 'Find and view existing agencies',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'agency-find' },
    searchTags: ['find agency', 'find agencies', 'view agency', 'view agencies', 'administration'],
    security: { check: true, permission: 'agencies', action: 'view' }
  },
  agencyTransfer: {
    title: 'Transfer Agency',
    details: 'Transfer an agency and the agency\'s client(s) assets to another Partner.',
    icon: 'exchange-alt',
    iconClass: 'color-purple-300',
    routerTo: { name: 'agency-transfer' },
    searchTags: ['agencies', 'agencies transfer', 'agency transfer', 'administration'],
    security: { check: true, permission: 'agencies', action: 'edit' }
  },
  clientCreate: {
    title: 'Add Client',
    details: 'Add a new client to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'client-create' },
    searchTags: ['add clients', 'administration'],
    security: { check: true, permission: 'clients', action: 'create' }
  },
  clientFind: {
    title: 'Find Client',
    details: 'Find and view existing clients',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'client-find' },
    searchTags: ['find clients', 'view clients', 'administration'],
    security: { check: true, permission: 'clients', action: 'view' }
  },
  clientContactFind: {
    title: 'Find Clients Contacts',
    details: 'Find and view contacts',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'client-contacts' },
    searchTags: ['find contacts', 'view contacts', 'administration'],
    security: { check: true, permission: 'clients', action: 'view' }
  },
  clientTransfer: {
    title: 'Transfer Client(s)',
    details: 'Transfer a client and the client\'s assets to another Partner and/or Agency.',
    icon: 'exchange-alt',
    iconClass: 'color-purple-300',
    routerTo: { name: 'client-transfer' },
    searchTags: ['clients', 'clients transfer', 'client transfer', 'administration'],
    security: { check: true, permission: 'clients', action: 'edit' }
  },
  userCreate: {
    title: 'Add User',
    details: 'Add a new user to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'user-create' },
    searchTags: ['add users', 'administration'],
    security: { check: true, permission: 'users', action: 'create' }
  },
  userFind: {
    title: 'Find User',
    details: 'Find and view existing users',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'user-find' },
    searchTags: ['find users', 'view users', 'administration'],
    security: { check: true, permission: 'users', action: 'view' }
  },
  myAccount: {
    title: 'My User Account',
    details: 'Manage your own user account',
    icon: 'user-circle',
    iconClass: 'color-deep-orange-300',
    routerTo: { name: 'user-profile-edit' },
    searchTags: ['my accounts', 'my user accounts', 'my user accounts'],
    security: { check: true, permission: 'users', action: 'view' }
  },
  myAccountRegister: {
    title: 'Register Someone Else',
    details: 'Register an additional person under your account via email',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'user-register' },
    searchTags: ['register users', 'my accounts', 'my user accounts', 'register someone else'],
    security: { check: true, permission: 'users', action: 'create' }
  },
  myAccountFindUser: {
    title: 'Find User',
    details: 'Find and manage previously registered users',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'user-find' },
    searchTags: [
      'find users',
      'view users',
      'register users',
      'my accounts',
      'my user accounts',
      'register someone else'
    ],
    security: { check: true, permission: 'users', action: 'view' }
  },
  unitCreate: {
    title: 'Add Unit',
    details: 'Add a new unit to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'unit-create' },
    searchTags: ['add units', 'add tracking units'],
    security: { check: true, permission: 'units', action: 'create' }
  },
  unitFind: {
    title: 'Find Unit',
    details: 'Find and view existing units',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'unit-find' },
    searchTags: ['find units', 'view units', 'find tracking units', 'view tracking units'],
    security: { check: true, permission: 'units', action: 'view' }
  },
  unitGroupCreate: {
    title: 'Add Unit Group',
    details: 'Add a new unit group to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'unit-group-create' },
    searchTags: ['add unit groups', 'add groups'],
    security: { check: true, permission: 'unit_groups', action: 'create' }
  },
  unitGroupFind: {
    title: 'Find Unit Group',
    details: 'Find and view existing unit groups',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'unit-group-find' },
    searchTags: ['find unit groups', 'view unit groups', 'find groups', 'view groups'],
    security: { check: true, permission: 'unit_groups', action: 'view' }
  },
  unitMultipleCreate: {
    title: 'Add Multiple Units',
    details: 'Allows you to add multiple units in a fast and efficient manner',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'multiple-unit-create' },
    searchTags: ['add multiple units', 'add multiple tracking units'],
    security: { check: true, permission: 'units', action: 'create' }
  },
  unitFindArchive: {
    title: 'Find Archived Units',
    details: 'Find and view previously archived units',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'unit-archive-find' },
    searchTags: [
      'find archived units',
      'view archived units',
      'find archived tracking units',
      'view archived tracking units'
    ],
    security: { check: true, permission: 'units', action: 'view' }
  },
  unitSwapping: {
    title: 'Unit Swapping',
    details: 'Allows units to be swapped to and from vehicles/clients',
    icon: 'exchange-alt',
    iconClass: 'color-purple-300',
    routerTo: { name: 'unit-swapping' },
    searchTags: ['unit swapping', 'units swapping', 'tracking unit swapping', 'tracking units swapping'],
    security: { check: true, permission: 'units', action: 'unit_swapping' }
  },
  unitStatusOverview: {
    title: 'Live Status Overview',
    details: 'Shows a live status overview of all the units on the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'status-overview' },
    searchTags: ['unit status overview', 'units status overview'],
    security: { check: true, permission: 'units', action: 'view' }
  },
  cfgTemplateCreate: {
    title: 'Add Configuration Template',
    details: 'Add a new unit configuration template that can be applied to units',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'cfg-template-create' },
    searchTags: ['add configuration templates', 'add config templates', 'tracking units', 'add units'],
    security: { check: true, permission: 'unit_cfg_templates', action: 'create' }
  },
  cfgTemplateFind: {
    title: 'Find Configuration Template',
    details: 'Find an existing unit configuration template',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'cfg-template-find' },
    searchTags: [
      'find configuration templates',
      'view configuration templates',
      'find unit configuration templates',
      'view unit configuration templates',
      'tracking units'
    ],
    security: { check: true, permission: 'unit_cfg_templates', action: 'view' }
  },
  reportDebriefDetailed: {
    title: 'Debrief Report (Detailed)',
    details: 'A report to debrief a driver on trips over a specified period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'debrief-detailed-report' },
    searchTags: ['report', 'debrief detailed', 'detailed debrief'],
    security: { check: true, permission: 'reports_history', action: 'debrief_detailed' }
  },
  reportDebriefSummary: {
    title: 'Debrief Report (Summary)',
    details: 'A daily summary report for one or more vehicles over a specified period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'debrief-summary-report' },
    searchTags: ['report', 'debrief summary', 'summary debrief'],
    security: { check: true, permission: 'reports_history', action: 'debrief_summary' }
  },
  reportVehicleAnalysis: {
    title: 'Vehicle Analysis Report',
    details: 'An analysis report for a selected vehicle over a specified period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'vehicle-analysis-report' },
    searchTags: ['report', 'vehicle analysis', 'analysis'],
    security: { check: true, permission: 'reports_history', action: 'vehicle_analysis' }
  },
  reportPositionLog: {
    title: 'Position Log Report',
    details: 'A position log report for a selected vehicle over a specified time period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'position-log-report' },
    searchTags: ['report', 'position log', 'position'],
    security: { check: true, permission: 'reports_history', action: 'position_log' }
  },
  reportDetailedEvents: {
    title: 'Vehicle/Unit Detailed Events Report',
    details: 'A detailed events report for a selected vehicle over a specified time period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'detailed-events-report' },
    searchTags: ['report', 'detailed events', 'events'],
    security: { check: true, permission: 'reports_events', action: 'events_detailed' }
  },
  reportEventsSummary: {
    title: 'Vehicle Events Summary Report',
    details: 'A events summary report for a selected vehicle/s over a specified period',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'events-summary-report' },
    searchTags: ['report', 'events summary', 'events'],
    security: { check: true, permission: 'reports_events', action: 'events_summary' }
  },
  reportVehicleExpenses: {
    title: 'Expenditure Report',
    details: 'A report that presents the expenditures/costs for one or more vehicles',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'expenses-report' },
    searchTags: ['report', 'expenditure', 'expenses'],
    security: { check: true, permission: 'reports_management', action: 'vehicle_expenses' }
  },
  reportUnitStatusDetailed: {
    title: 'Unit Operational Status Report',
    details: 'A detailed operational status report for a selection of units',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'status-units-detailed-report' },
    searchTags: ['status', 'status detailed', 'units'],
    security: { check: true, permission: 'reports_status', action: 'status_units_detailed' }
  },
  reportUnitStatusSummary: {
    title: 'Unit Comms Status Report',
    details: 'A summary report showing the communication status of units',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'status-units-summary-report' },
    searchTags: ['status', 'status summary', 'units'],
    security: { check: true, permission: 'reports_status', action: 'status_units_detailed' }
  },
  reportEventPoolDetailed: {
    title: 'Event Pool Detailed Report',
    details: 'A detailed report showing events from a selected pool.',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'events-pool-detailed-report' },
    searchTags: ['event', 'event pool', 'detailed', 'report'],
    security: { check: true, permission: 'reports_events', action: 'event_pool_report' }
  },
  reportEventPoolSummary: {
    title: 'Event Pool Summary Report',
    details: 'A summary report showing events from a selected pool.',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'events-pool-summary-report' },
    searchTags: ['event', 'event pool', 'summary', 'report'],
    security: { check: true, permission: 'reports_events', action: 'event_pool_report' }
  },
  reportVehicleSpeedingDetailed: {
    title: 'Vehicle Speeding Detailed Report',
    details: 'A detailed report showing speeding events from a selected vehicle.',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'speeding-detailed-report' },
    searchTags: ['vehicle', 'speeding', 'detailed', 'report'],
    security: { check: true, permission: 'reports_history', action: 'vehicle_speeding' }
  },
  reportVehicleSpeedingSummary: {
    title: 'Vehicle Speeding Summary Report',
    details: 'A summary report showing speeding events from selected vehicles.',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'speeding-summary-report' },
    searchTags: ['vehicle', 'speeding', 'summary', 'report'],
    security: { check: true, permission: 'reports_history', action: 'vehicle_speeding' }
  },
  reportVehicleMaintenance: {
    title: 'Vehicle Maintenance Report',
    details: 'A vehicle maintenance report showing licence, permit and scheduled maintenance expiry dates.',
    icon: 'file-chart-line',
    iconClass: 'color-green-300',
    routerTo: { name: 'vehicle-maintenance-report' },
    searchTags: ['vehicle', 'maintenance', 'report'],
    security: { check: true, permission: 'reports_management', action: 'vehicle_maintenance' }
  },
  monitoredEventProfilesCreate: {
    title: 'Add Monitored Event Profile',
    details: 'Add a new monitored event profile to the system.',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'monitored-event-profile-create' },
    searchTags: ['add monitored event profile', 'add monitored event', 'monitored'],
    security: { check: false, permission: 'event_profiles_monitored', action: 'create' }
  },
  monitoredEventProfilesFind: {
    title: 'Find Monitored Event Profile',
    details: 'Find and view existing monitored event profiles.',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'monitored-event-profile-find' },
    searchTags: ['find monitored event profile', 'find monitored event', 'monitored'],
    security: { check: false, permission: 'event_profiles_monitored', action: 'view' }
  },
  eventProfilesCreate: {
    title: 'Add Client Event Profile',
    details: 'Add a new event profile to the system.',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'client-event-profile-create' },
    searchTags: ['add event profile', 'add event'],
    security: { check: false, permission: 'event_profiles_client', action: 'create' }
  },
  eventProfilesFind: {
    title: 'Find Client Event Profile',
    details: 'Find and view existing event profiles.',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'client-event-profile-find' },
    searchTags: ['find event profile', 'find event'],
    security: { check: false, permission: 'event_profiles_client', action: 'view' }
  },
  eventProfilesClone: {
    title: 'Clone Client Event Profile',
    details: 'Clones an existing event profile.',
    icon: 'copy',
    iconClass: 'color-blue-300',
    routerTo: { name: 'client-event-profile-clone' },
    searchTags: ['clone event profile', 'clone event', 'copy event'],
    security: { check: false, permission: 'event_profiles_client', action: 'create' }
  },
  eventPoolsCreate: {
    title: 'Add Event Pools',
    details: 'Add a new event pool to the system.',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'event-pool-create' },
    searchTags: ['add event pool', 'add event'],
    security: { check: false, permission: 'event_pools', action: 'create' }
  },
  eventPoolsFind: {
    title: 'Find Event Pools',
    details: 'Find and view existing event pools.',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'event-pool-find' },
    searchTags: ['find event pool', 'find event'],
    security: { check: false, permission: 'event_pool', action: 'view' }
  },
  simCardsCreate: {
    title: 'Add Sim Cards',
    details: 'Add a new sim card to the system.',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'sim-card-create' },
    searchTags: ['add sim card', 'add sim', 'sim', 'card'],
    security: { check: false, permission: 'sim_cards', action: 'create' }
  },
  simCardsFind: {
    title: 'Find Sim Cards',
    details: 'Find and view existing sim cards.',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'sim-card-find' },
    searchTags: ['find sim card', 'find sim', 'sim', 'card'],
    security: { check: false, permission: 'sim_cards', action: 'view' }
  },
  gdspoSimCardsFind: {
    title: 'Find GDSPO Sim Cards',
    details: 'Find and view existing GDSPO sim cards.',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'gdspo-sim-card-find' },
    searchTags: ['find sim card', 'find sim', 'sim', 'card', 'gdspo'],
    security: { check: false, permission: 'gdspo', action: 'view' }
  },
  unitCommandCreate: {
    title: 'Add Unit Command',
    details: 'Add a new unit command to the system',
    icon: 'plus-circle',
    iconClass: 'color-blue-300',
    routerTo: { name: 'unit-command-create' },
    searchTags: ['add unit commands', 'add commands'],
    security: { check: true, permission: 'unit_commands', action: 'create' }
  },
  unitCommandFind: {
    title: 'Find Unit Command',
    details: 'Find and view existing unit commands',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'unit-command-find' },
    searchTags: ['find unit commands', 'view unit commands', 'find commands', 'view commands'],
    security: { check: true, permission: 'unit_commands', action: 'view' }
  },
  unitCommandPermissions: {
    title: 'Unit Command Management',
    details: 'Manage unit command permissions and limits',
    icon: 'check-square',
    iconClass: 'color-blue-300',
    routerTo: { name: 'unit-command-permission' },
    searchTags: ['unit commands', 'unit commands permission', 'permission'],
    security: { check: true, permission: 'unit_commands', action: 'manage_permissions' }
  },
  unitCommandLogs: {
    title: 'Find Unit Command Logs',
    details: 'Find existing unit commands logs',
    icon: 'search',
    iconClass: 'color-green-300',
    routerTo: { name: 'unit-command-log' },
    searchTags: ['unit commands', 'unit commands log', 'log'],
    security: { check: true, permission: 'unit_commands', action: 'view_command_logs' }
  }
}



// WEBPACK FOOTER //
// ./src/common/menu.js